import React, { useRef, useState } from 'react';

import { Formik } from 'formik';
import * as Yup from 'yup';

import { setUploadErrors } from 'Helpers/errors';

import LoadingSpinner from 'CommonComponents/LoadingSpinner';
import ModalFooter from 'CommonComponents/ModalFooter';
import TextareaFormField from 'CommonComponents/TextareaFormField';
import TextFormField from 'CommonComponents/TextFormField';

const GeneralSupplierAddSchema = Yup.object().shape({
    name: Yup.string().required($t('This value is required')),
    type: Yup.string().required($t('This value is required')),
    location: Yup.string().required($t('This value is required')),
    area_operation: Yup.string(),
    services_description: Yup.string(),
    key_contact: Yup.string(),
    website: Yup.string(),
    contact_details: Yup.string(),
});

export default function SupplierFrameworkAddSupplierForm(props) {
    const fileRef = useRef();
    const [request, setRequest] = useState(false);

    return (
        <Formik
            initialValues={{
                name: '',
                type: '',
                location: '',
                area_operation: '',
                services_description: '',
                key_contact: '',
                website: '',
                contact_details: '',
                files: [],
            }}
            validationSchema={GeneralSupplierAddSchema}
            onSubmit={(values, actions) => {
                setRequest(true);

                const formData = new FormData();
                Object.keys(values).forEach((key) => {
                    if (key === 'files') {
                        Array.from(values[key]).forEach((file) => {
                            formData.append('files[]', file);
                        });
                    } else {
                        formData.append(key, values[key]);
                    }
                });

                axios({
                    method: 'post',
                    url: props.saveUrl,
                    data: formData,
                    headers: { 'Content-Type': 'multipart/form-data' },
                })
                    .then((response) => {
                        props.fetchCommonData();
                        props.setSupplierIsAdded(true);
                        actions.resetForm();
                    })
                    .catch((e) => {
                        actions.setErrors(e.response.data.errors);
                        setUploadErrors(e, 'files.0', 'files', actions);
                    })
                    .finally(() => {
                        actions.setSubmitting(false);
                        setRequest(false);
                    });
            }}
        >
            {({ values, errors, touched, isSubmitting, handleSubmit, setFieldValue, resetForm }) => (
                <>
                    <div className="tw-grid tw-grid-cols-1">
                        <TextFormField
                            label={$t('Supplier Name')}
                            required={true}
                            type="text"
                            name="name"
                            placeholder={$t('Enter supplier name')}
                        ></TextFormField>
                    </div>

                    <div className="tw-grid tw-grid-cols-1">
                        <TextFormField label={$t('Type')} required={true} type="text" name="type" placeholder={$t('Enter type')}></TextFormField>
                    </div>

                    <div className="tw-grid tw-grid-cols-1">
                        <TextareaFormField
                            label={$t('Office Location')}
                            required={true}
                            as={'textarea'}
                            type="text"
                            name="location"
                            placeholder={$t('Enter Office Location')}
                        ></TextareaFormField>
                    </div>

                    <div className="tw-grid tw-grid-cols-1">
                        <TextareaFormField
                            label={$t('Area of Operation')}
                            as={'textarea'}
                            type="text"
                            name="area_operation"
                            placeholder={$t('Enter Area of Operation')}
                        ></TextareaFormField>
                    </div>

                    <div className="tw-grid tw-grid-cols-1">
                        <TextareaFormField
                            label={$t('Description of services')}
                            as={'textarea'}
                            type="text"
                            name="services_description"
                            placeholder={$t('Enter Description of services')}
                        ></TextareaFormField>
                    </div>

                    <div className="tw-grid tw-grid-cols-1">
                        <TextFormField label={$t('Key Contact')} type="text" name="key_contact" placeholder={$t('Enter Key Contact')}></TextFormField>
                    </div>

                    <div className="tw-grid tw-grid-cols-1">
                        <TextFormField label={$t('Website')} type="text" name="website" placeholder={$t('Enter Website')}></TextFormField>
                    </div>

                    <div className="tw-grid tw-grid-cols-1">
                        <TextareaFormField
                            label={$t('Contact Details')}
                            as={'textarea'}
                            type="text"
                            name="contact_details"
                            placeholder={$t('Enter Contact Details')}
                        ></TextareaFormField>
                    </div>

                    <div className="tw-grid tw-grid-cols-1">
                        <div className="tw-flex tw-flex-col tw-space-y-1.5">
                            <label htmlFor="files" className="text-input__label">
                                {$t('Attachments')}
                            </label>
                            <input
                                ref={fileRef}
                                type="file"
                                className={errors.files && touched.files ? 'tw-border tw-border-red-500 file-input' : 'tw-border-0 file-input'}
                                name="files"
                                multiple
                                placeholder="Select Files"
                                accept={ACCEPTED_ATTACHMENT_FILE_TYPES}
                                onChange={(event) => {
                                    setFieldValue('files', event.currentTarget.files);
                                }}
                            />
                            {errors.files && touched.files && <div className="tw-text-red-500 tw-text-sm">{errors.files}</div>}
                        </div>
                    </div>

                    {request && (
                        <div className="tw-grid tw-grid-cols-1">
                            <div className="tw-flex tw-justify-center tw-items-center tw-space-y-1.5">
                                <LoadingSpinner></LoadingSpinner>
                            </div>
                        </div>
                    )}

                    <ModalFooter
                        cancelButtonText={$t('Cancel')}
                        primaryButtonText={$t('Store')}
                        onCancel={props.internalCloseHandler}
                        handleSubmit={handleSubmit}
                        isSubmitting={props.request}
                    ></ModalFooter>
                </>
            )}
        </Formik>
    );
}
